import { render, staticRenderFns } from "./CommissionWidget.vue?vue&type=template&id=77a101d7&scoped=true"
import script from "./CommissionWidget.vue?vue&type=script&lang=js"
export * from "./CommissionWidget.vue?vue&type=script&lang=js"
import style0 from "./CommissionWidget.vue?vue&type=style&index=0&id=77a101d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a101d7",
  null
  
)

export default component.exports